/* Iron Threads v2 draft (2026-11-02): tabbed product rails and rail arrows. */
(function () {
  "use strict";

  document.querySelectorAll("[data-v2-rail]").forEach(function (sec) {
    var tabs = Array.prototype.slice.call(sec.querySelectorAll('[role="tab"]'));
    var prev = sec.querySelector("[data-rail-prev]");
    var next = sec.querySelector("[data-rail-next]");

    function activeRail() {
      var panel = sec.querySelector(".v2-rail-panel:not([hidden])");
      return panel && panel.querySelector("[data-rail]");
    }
    function syncArrows() {
      var r = activeRail();
      if (!r || !prev || !next) return;
      var max = r.scrollWidth - r.clientWidth - 2;
      prev.disabled = r.scrollLeft <= 2;
      next.disabled = r.scrollLeft >= max;
    }
    function step(dir) {
      var r = activeRail();
      if (!r) return;
      var card = r.firstElementChild;
      var gap = parseFloat(getComputedStyle(r).columnGap) || 0;
      var w = card ? card.getBoundingClientRect().width + gap : r.clientWidth;
      var per = Math.max(1, Math.floor((r.clientWidth + gap) / w));
      var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      r.scrollBy({ left: dir * w * per, behavior: reduce ? "auto" : "smooth" });
    }
    if (prev) prev.addEventListener("click", function () { step(-1); });
    if (next) next.addEventListener("click", function () { step(1); });
    sec.querySelectorAll("[data-rail]").forEach(function (r) {
      r.addEventListener("scroll", syncArrows, { passive: true });
    });

    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute("aria-selected", on ? "true" : "false");
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute("aria-controls"));
        if (p) p.hidden = !on;
      });
      if (focus) tab.focus();
      var r = activeRail();
      if (r) r.scrollLeft = 0;
      syncArrows();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener("click", function () { select(t, false); });
      t.addEventListener("keydown", function (e) {
        var k = e.key, j = -1;
        if (k === "ArrowRight") j = (i + 1) % tabs.length;
        else if (k === "ArrowLeft") j = (i - 1 + tabs.length) % tabs.length;
        else if (k === "Home") j = 0;
        else if (k === "End") j = tabs.length - 1;
        if (j > -1) { e.preventDefault(); select(tabs[j], true); }
      });
    });
    syncArrows();
    window.addEventListener("resize", syncArrows, { passive: true });
  });
})();
